import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@theneatcompany/nui'
import cx from 'classnames'

import { NEAT_DATA_URL } from '@/config'
import { Column, Row } from '@/components/layout'
import { Link, Text } from '@/components/common'

import styles from './WebinarItem.module.scss'

const updateImagePath = path => (path ? `${NEAT_DATA_URL}/webinars/${path}` : path)

const parseStringToParagraphs = text => {
  if (typeof text !== 'string') return ''

  return text.split('\n').map((line, index) => (
  // eslint-disable-next-line react/no-array-index-key
    <p key={index} style={{ color: '#FFF' }}>
      {line}
    </p>
  ))
}

const WebinarItem = ({
  presenters,
  webinarTitle,
  webinarUrl,
  webinarBtnText = 'Watch Now',
  webinarImg,
  isUpcoming,
}) => (
  <Column className={styles.webinarItem} size={60}>
    <Row className={styles.thumbnail}>
      <img alt={webinarTitle} src={updateImagePath(webinarImg)} />
    </Row>
    <div className={cx(styles.presenterContainer, (!isUpcoming && presenters.length > 1 && styles.allPresenters))}>
      <Text.H4 brandPrimary>Presenter{presenters.length > 1 ? 's' : ''}</Text.H4>
      <Row className={styles.presentersImg}>
        {presenters.map((presenter) => (
          <Tooltip
            key={presenter.id}
            content={
              <div className={styles.tooltipPresenter}>
                <h4>{presenter.name}</h4>
                <h5>{presenter.title}</h5>
                <p>{parseStringToParagraphs(presenter.bio)}</p>
              </div>
            }
            placement="bottom"
          >
            <img alt={presenter.name} src={updateImagePath(presenter.img)} />
          </Tooltip>
        ))}
      </Row>
    </div>
    <Column className={styles.details}>
      <Text.H3 brandPrimary>{webinarTitle}</Text.H3>
      <Link size="large" to={webinarUrl} variant="primary">
        {webinarBtnText}
      </Link>
    </Column>
  </Column>
)

WebinarItem.propTypes = {
  presenters: PropTypes.arrayOf(PropTypes.shape({
    bio: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    img: PropTypes.string.isRequired,
  })),
  webinarTitle: PropTypes.string.isRequired,
  webinarUrl: PropTypes.string.isRequired,
  webinarBtnText: PropTypes.string,
  webinarImg: PropTypes.string.isRequired,
  isUpcoming: PropTypes.bool,
}

export default WebinarItem
